import React, { FC, ReactNode } from "react";
import { Box, AppBar, useScrollTrigger } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from "@mui/icons-material/Instagram";
import { FaXTwitter as TwitterIcon } from "react-icons/fa6"; //temporary solution until MUI includes new Twitter icon X
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { DEMO_REQUEST } from "@/settings/ctaAction";
import { graphql, useStaticQuery } from "gatsby";
import { SanityPost } from "@/types/sanityPost";

export const MainLayout: FC<Props> = ({ children }) => {
  const headerElevationTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38
  });

  const {
    allSanityPost: { nodes }
  } = useStaticQuery<{
    allSanityPost: { nodes: SanityPost[] };
  }>(graphql`
    query {
      allSanityPost(filter: { _id: { glob: "!drafts.*" } }) {
        nodes {
          _id
        }
      }
    }
  `);

  const blogNotEmpty = !!nodes.length;

  return (
    <Box>
      <AppBar
        position="sticky"
        sx={{
          top: 0,
          backgroundColor: theme => theme.palette.background.paper
        }}
        elevation={headerElevationTrigger ? 1 : 0}
      >
        <Header
          cta={{
            label: "Book a Demo",
            href: DEMO_REQUEST
          }}
          navItems={[
            { label: "Features", to: "/#features" },
            { label: "Integrations", to: "/#integrations" },
            ...(blogNotEmpty ? [{ label: "Blog", to: "/blog" }] : [])
          ]}
          headerTo="/"
        />
      </AppBar>
      <main>{children}</main>
      <Footer
        contacts={[
          {
            label: "Email",
            contact: {
              label: "info@10speed.cloud",
              href: "mailto:info@10speed.cloud"
            }
          },
          {
            label: "Phone",
            contact: {
              label: "(708) 880-9915",
              href: "tel:(708) 880-9915"
            }
          },
          {
            label: "Follow us",
            socialLinks: [
              {
                label: "Linkedin",
                href: "https://www.linkedin.com/company/10speed/",
                icon: <LinkedInIcon fontSize="inherit" />
              },
              {
                label: "Facebook",
                href: "https://www.facebook.com/10-Speed-115673444927012/",
                icon: <FacebookIcon fontSize="inherit" />
              },
              {
                label: "YouTube",
                href: "https://youtube.com/@10speed_tms",
                icon: <YouTubeIcon fontSize="inherit" />
              },
              {
                label: "Instagram",
                href: "https://www.instagram.com/10speed_tms/",
                icon: <InstagramIcon fontSize="inherit" />
              },
              {
                label: "Twitter",
                href: "https://twitter.com/10speed_tms",
                icon: <TwitterIcon style={{ transform: "scale(0.9)" }} />
              }
            ]
          }
        ]}
        footerLinks={[
          {
            label: "Privacy Policy",
            to: "/privacy"
          }
        ]}
        copyright="© 10 Speed LLC. 2023, All rights reserved"
      />
    </Box>
  );
};

interface Props {
  children: ReactNode;
}
